

























































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import axios from "axios";
import { General } from "@/services/General";
import { Sign } from "@/entity/Sign";
import { DropDownItem } from "@/services/DropDownItem";
import { Garage } from "@/entity/Garage";

@Component
export default class GarageSignDetails extends Vue {
  @Prop({ type: Boolean, required: true })
  editMode;
  @Prop({ required: false })
  garage: Garage;
  @Prop({ required: false })
  sign: Sign;

  GRAPHICS_SOURCE = "SIGNS_GRAPHICS";

  signLoaded: Sign = new Sign();
  loading: boolean = false;
  optionsGraphics: any = new Array();
  isSaveClicked: boolean = false;

  async mounted() {
    this.loading = true;
    this.optionsGraphics = await this.getDropDownListBySourceCode(this.GRAPHICS_SOURCE);
    if(this.editMode){
      this.signLoaded = {...this.sign};
    }
    this.loading = false;
  }

  returnState(condition: boolean, clickButton: boolean): boolean {
    if (clickButton) 
      return condition;
    else 
      return null;
  }

  async getDropDownListBySourceCode(sourceCode: string) : Promise<Array<any>>{
    try{
        let response = await axios.get<DropDownItem[]>(
            General.GetApiUrl('/api/DropDownItem/GetDropDownItemsBySourceCode?codDropDownSource=' + sourceCode),{
            responseType: "json",
            withCredentials: true
        });
    if(response.data)
        return this.setOptions(response.data);
    }catch(ex){
        General.HandleError(ex, this);
        return null;
    }
  }

  setOptions(dropDownItems: DropDownItem[]) {
    let array: Array<any> = [];

    array.push({ value: null, text: "" });


    dropDownItems.forEach(function (el) {
    array.push({ value: el.idDropDownItem, text: el.itemText });
    });
    return array;
  }

  copyFromGarage() {
    this.signLoaded.indirizzoConsegna = this.garage.indirizzo;
    this.signLoaded.localitaConsegna = this.garage.localita;
    this.signLoaded.capConsegna = this.garage.cap;
    this.signLoaded.provinciaConsegna = this.garage.provincia;
  }

  copyFromSignDeliverInfo() {
    this.signLoaded.indirizzoEsposizione = this.signLoaded.indirizzoConsegna;
    this.signLoaded.localitaEsposizione = this.signLoaded.localitaConsegna;
    this.signLoaded.capEsposizione = this.signLoaded.capConsegna;
    this.signLoaded.provinciaEsposizione = this.signLoaded.provinciaConsegna;
  }

  async addOrUpdateSign(sign: Sign) {
    this.isSaveClicked = true;
    if(!sign.codiceGrafica || !sign.tipo || 
        !sign.indirizzoConsegna || !sign.localitaConsegna || !sign.capConsegna || ! sign.provinciaConsegna || 
        !sign.indirizzoEsposizione || !sign.localitaEsposizione || !sign.capEsposizione || ! sign.provinciaEsposizione) {
        General.showAlertDanger("Verificare campi obbligatori", this);
    } else {
      if(this.editMode)
        await this.updateSignDo(sign);
      else
        await this.insertSignDo(sign);
    }
  } 

  async insertSignDo(sign: Sign) {
    sign.idGarage = this.garage.id;
    General.confirm(
      "Confermi di voler creare una nuova insegna?",
      this,
      async () => {
        await this.insertSign(sign);
      }
    );
  }

  async insertSign(sign: Sign) {
    try {
      this.loading = true;
      let response = await axios({
        method: "post",
        url: General.GetApiUrl("/api/sign/CreateSign"),
        data: sign,
        withCredentials: true,
        responseType: "json",
      });
      if(response.data != null) {
        sign.id = response.data;
        General.showAlertSuccess("Insegna creata", this);
        this.afterInsertOrUpdateSign(sign);
      }
    } catch (error) {
      General.HandleError(error, this);
    } finally {
      this.loading = false;
    }
  }

  async updateSignDo(sign: Sign) {
    General.confirm(
      "Confermi di voler aggiornare l'insegna?",
      this,
      async () => {
        await this.updateSign(sign);
      }
    );
  }

  async updateSign(sign: Sign) {
    try {
      this.loading = true;
      await axios({
        method: "post",
        url: General.GetApiUrl("/api/sign/UpdateSign"),
        data: sign,
        withCredentials: true,
        responseType: "json",
      });
      General.showAlertSuccess("Insegna aggiornata", this);
      this.afterInsertOrUpdateSign(sign);
    } catch (error) {
      General.HandleError(error, this);
    } finally {
      this.loading = false;
    }
  }

  afterInsertOrUpdateSign(sign: Sign) {
    this.isSaveClicked = false;
    this.closeDetailModal();
    this.$emit("actionOnSigns", sign, this.editMode);
  }

  closeDetailModal() {
    this.$bvModal.hide("garage-sign-details-modal");
  }
}
